export default {
  'v-form': () => import('@/components/v-form.vue'),
  'portfolio-card': () => import('@/components/portfolio-card.vue'),
  'service-card': () => import('@/components/service-card.vue'),
  'portfolio-listing': () => import('@/components/portfolio-listing.vue'),
  'portfolio-home-featured': () => import('@/components/portfolio-home-featured.vue'),
  'portfolio-home-simple': () => import('@/components/portfolio-home-simple.vue'),
  'service-listing': () => import('@/components/service-listing.vue'),
  'gallery-slider': () => import('@/components/gallery-slider.vue'),
  'pagination': () => import('@/components/pagination.vue'),
  'v-cookie-consent': () => import('@/components/v-cookie-consent.vue'),
  'v-modal-form-provider': () => import('@/components/v-modal-form-provider.vue'),
  'v-contacts-map': () => import('@/components/v-contacts-map.vue'),
  'variants-block': () => import('@/components/variants-block.vue'),
  'calc-renovation': () => import('@/components/calc-renovation.vue'),
  'about-carousel': () => import('@/components/about-carousel.vue'),
  'benefits-cards': () => import('@/components/benefits-cards.vue'),
  'packages-carousel': () => import('@/components/packages-carousel.vue'),
};
